import { ChevronDown, Close } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import dropdownStyles from "../../../dropdown/Dropdown.module.js";
import { Input } from "../../../input/Input.js";
import styles from "../../MultiSelect.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const MultiSelectInput = ({
  className,
  outerRef,
  value,
  label,
  onMouseDown,
  onIconClick,
  onChange,
  inputRef,
  searchable,
  open = false,
  ...props
}) => {
  const classes = classnames(dropdownStyles.dropdown, props.small && dropdownStyles.small, className);
  const showCloseIcon = open && searchable && value;
  return /*#__PURE__*/_jsx("div", {
    ref: outerRef,
    className: classes,
    children: /*#__PURE__*/_jsx(Input, {
      ...props,
      label: label,
      className: classnames(dropdownStyles.inputContainer, styles.input),
      value: value,
      readOnlyWithStandardStyle: !searchable,
      onChange: onChange,
      onMouseDown: onMouseDown,
      onIconClick: onIconClick,
      disableIconFocus: true,
      icon: showCloseIcon ? /*#__PURE__*/_jsx(Close, {}) : /*#__PURE__*/_jsx(ChevronDown, {
        className: classnames(styles.dropdownChevron, {
          [styles.open]: open
        })
      }),
      inputRef: inputRef
    })
  });
};